<template>
    <div>
        <el-dialog title='修改发票' :visible.sync='updatevatdiag' :close-on-click-modal='false'
                   :close-on-press-escape='false'
                   width='90%' v-dialogDrag @close='close' append-to-body>
            <div class='Centerupdown'>
                <el-button type='primary' @click='updateFeeInvoice'>保存</el-button>
                <el-button type='primary' @click='downloadImage'>图像下载</el-button>
                <el-button type='primary' @click='selfStudy' v-if="updateformdata != null && updateformdata.invoiceType == '701'">自主学习</el-button>
            </div>
            <div class='between-space' style='margin-top: 20px;'>
                <div>
                    <taxform :Formlist='updateformlist' :column='2' @getdata='getdata' :formdata='updateformdata'
                             @selectchange='selectchange'
                             ref='taxform' labelwidth='100px'>
                    </taxform>
                    <div v-if='feeInvoiceDetailList.length > 0' style='margin-top: 20px;'>
                        <div class='titledetail'>发票详情信息</div>
                        <div v-for='(detail, index) in feeInvoiceDetailList' :key='detail.id' :style="index == 0 ? 'margin-top: 10px;' : 'margin-top: -5px;'">
                            <div class='between-space'>
                                <!-- <div class='detail-title'>明细 {{ index + 1 }}</div> -->
                                <div class='detail-title' :style="index == 0 ? 'margin-top: 10px;' : 'margin-top: 5px;'">明细 {{ index + 1 }}</div>
                                <el-button type='primary' @click='deleteDetail(index)' style='width: 50px;height: 32px;margin-left: 10px;'>删除</el-button>
                            </div>
                            <taxform :Formlist='detailFormList' :column='2' :formdata='detail' labelwidth='130px'>
                            </taxform>
                        </div>
                    </div>
                    <div style='margin-top: 10px;'>
                        <el-button type='primary' size='small' @click='addDetail'>添加明细</el-button>
                    </div>
                </div>
                <div class='fprightimg'>
                    <img class='imgfp' id='pic_cwctImg' v-show='notemptyandnull(imgblob)' :src="imgblob" />
                    <iframe v-if='notemptyandnull(pdfurl)' :src='pdfurl' scrolling='yes' frameborder='0'
                            style='width: 100%; height: 100%' />
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getCurrentUserCompany, getFilePath, getInvoiceInfo, updateFeeInvoice, selfStudy } from '../../../../api/home';
import http from '../../../../../configHttp.js';
import axios from 'axios';

export default {
    components: {},
    props: {
        updatevatdiag: {
            type: Boolean,
            default: false
        },
        invoiceId: {
            type: Number,
            default: 0
        }
    },
    watch: {
        updatevatdiag: function(indexVal, oldVal) {
            if (indexVal) {
                getCurrentUserCompany().then(res => {
                    this.companyList = res.data.data.map(item => {
                        item.label = item.code;
                        item.value = item.code;
                        return item;
                    });
                });
                getInvoiceInfo(this.invoiceId).then(res => {
                        if (res.data.success) {
                            this.updateformdata = res.data.data;
                            this.feeInvoiceDetailList = res.data.data.feeInvoiceDetailList || [];
                            this.imgblob = '';
                            this.pdfurl = '';
                            let fileName = this.updateformdata.fileName.toLowerCase();
                            if (fileName.endsWith('jpg') || fileName.endsWith('jpeg') || fileName.endsWith('png')) {
                                // var box = document.getElementById('pic_cwctImg');
                                // if (box) {
                                //     box.remove();
                                // }
                                this.toseeimg();
                            } else if (fileName.endsWith('pdf') || fileName.endsWith('ofd')) {
                                this.getFilePath();
                            }
                        }
                    });
            }
        }
    },
    data() {
        return {
            imgblob: '',
            pdfurl: '',
            feeInvoiceDetailList: [],
            companyList: [],
            detailFormList: [
                { prop: 'lineNumber', label: '行号', type: 'input', isnumber: true },
                { prop: 'goodsName', label: '商品名称', type: 'input' },
                { prop: 'specificationModel', label: '规格型号', type: 'input' },
                { prop: 'quantity', label: '数量', type: 'input', isnumber: true },
                { prop: 'amount', label: '金额', type: 'input', isnumber: true },
                { prop: 'goodsCode', label: '商品代码', type: 'input' },
                { prop: 'taxRate', label: '税率', type: 'select', selectval: JSON.parse(JSON.stringify(this.taxRates)) },
                { prop: 'unit', label: '单位', type: 'input' },
                { prop: 'unitPrice', label: '单价', type: 'input', isnumber: true },
                { prop: 'taxAmount', label: '税额', type: 'input', isnumber: true }
            ],
            baseFormList: [
                {
                    prop: 'companyCode',
                    label: '公司代码',
                    type: 'select',
                    isnotnull: true
                },
                {
                    prop: 'invoiceType',
                    label: '票据类型',
                    type: 'select',
                    isnotnull: true,
                    selectchange: true,
                    selectval: JSON.parse(JSON.stringify(this.invoiceTypes))
                },
                {
                    prop: 'invoiceCode',
                    label: '发票代码',
                    type: 'input'
                },
                {
                    prop: 'invoiceNumber',
                    label: '发票号码',
                    type: 'input',
                    isnotnull: true
                },
                {
                    prop: 'invoiceDate',
                    label: '开票日期',
                    type: 'date',
                    isdate: true,
                    valueformat: 'yyyyMMdd',
                    unlinkpanels: true,
                    isnotnull: true
                },
                {
                    prop: 'amount',
                    label: '发票金额(不含税)',
                    type: 'input',
                    isnumber: true
                },
                {
                    prop: 'totalAmount',
                    label: '发票金额(含税)',
                    type: 'input',
                    isnotnull: true,
                    isnumber: true
                },
                {
                    prop: 'tax',
                    label: '税额',
                    type: 'input',
                    isnumber: true
                },
                {
                    prop: 'taxRate',
                    label: '税率',
                    type: 'select',
                    // isnotnull: true,
                    selectval: JSON.parse(JSON.stringify(this.taxRates))
                },
                {
                    prop: 'buyerTaxNumber',
                    label: '购方税号',
                    type: 'input',
                    istosee: true
                },
                {
                    prop: 'supplierTaxNumber',
                    label: '销方税号',
                    type: 'input'
                },
                {
                    prop: 'supplierName',
                    label: '销方名称',
                    type: 'input'
                },
                {
                    prop: 'poNumber',
                    label: '发票PO',
                    type: 'input'
                },
                {
                    prop: 'inspectionStatus',
                    label: '查验结果',
                    type: 'select',
                    istosee: true,
                    selectval: JSON.parse(JSON.stringify(this.invoiceInspStatus))
                },
                {
                    prop: 'currency',
                    label: '币种',
                    type: 'input'
                },
                {
                    prop: 'checkCode',
                    label: '校验码',
                    type: 'input',
                    istosee: true
                },
                {
                    prop: 'sourceTax',
                    label: '源泉税',
                    type: 'input'
                }
            ],
            updateformdata: {}
        };
    },
    computed: {
        updateformlist() {
            let formList = JSON.parse(JSON.stringify(this.baseFormList));
            formList[0].selectval = this.companyList;
            if (this.updateformdata.invoiceType === '701') {
                formList.splice(13, 0,
                    {
                        prop: 'poDate',
                        label: 'PO日期',
                        type: 'date',
                        isdate: true,
                        valueformat: 'yyyy-MM-dd',
                        unlinkpanels: true
                    },
                    {
                        prop: 'deliveryNoteNumber',
                        label: '送货单号',
                        type: 'input'
                    },
                    {
                        prop: 'deliveryNoteDate',
                        label: '送货单日期',
                        type: 'date',
                        isdate: true,
                        valueformat: 'yyyy-MM-dd',
                        unlinkpanels: true                                  
                    }
                );

                formList.splice(19, 0,
                    {
                        prop: 'packagingFee',
                        label: '包装费',
                        type: 'input',
                        isnumber: true
                    },
                    {
                        prop: 'freightFee',
                        label: '运费',
                        type: 'input',
                        isnumber: true
                    }
                );
            }
            return formList;
        }
    },
    methods: {
        updateFeeInvoice() {
            this.$refs.taxform.submitForm();
        },

        selfStudy() {
            let feeInvoice = { ...this.updateformdata };
            feeInvoice.feeInvoiceDetailList = this.feeInvoiceDetailList;
            selfStudy(feeInvoice).then(res => {
                if (res.data.success) {
                    this.$message.success('自主学习成功');
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(err => {
                this.$message.error('自主学习失败');
            });
        },

        // 票据类型切换事件
        selectchange(e) {
            console.log(e);
        },
        getFilePath() {
            console.log('update view img->' + this.updateformdata.fileUrl);
            getFilePath({
                filePath: this.updateformdata.fileUrl
            }).then(res => {
                this.pdfurl = res.data.data;
                this.pdfurl = this.pdfurl.replace(/\\/g, '/');
            });
        },
        toseeimg() {
            axios.defaults.timeout = 600000; //响应时间
            axios({
                method: 'post',
                url: http.baseURL + 'fee/invoice/getFileStream',
                headers: {
                    'token': localStorage.getItem('token')
                },
                data: {
                    'filePath': this.updateformdata.fileUrl,
                    'fileName': this.updateformdata.fileName
                },
                responseType: 'blob'
            }).then((res) => {
                this.imgblob = new Blob([res.data], {
                    type: 'image/jpeg'
                });
                var _this=this
                this.blobToDataURI(this.imgblob, function(result) { //blob格式再转换为base64格式
                    // document.getElementById('pic_cwctImg').src = result;
                    _this.imgblob=result
                });

            });
        },
        close() {
            this.$emit('closeupdatevatdiag', false);
        },
        getdata(data) {
            data.feeInvoiceDetailList = this.feeInvoiceDetailList;
            updateFeeInvoice(data).then(res => {
                if (res.data.success) {
                    this.$message.success('修改成功');
                    this.close();
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        downloadImage() {
            let fileType = this.updateformdata.fileName.substring(this.updateformdata.fileName.lastIndexOf('.') + 1);
            let obj = {
                downUrl: http.baseURL + 'fee/invoice/getFileStream',//后台接口地址
                typeObj: {
                    toForm: false,//是否form提交
                    fileType: fileType,//要下载的文件类型
                    fileName: this.updateformdata.fileName//不定义则会取content-disposition
                },
                params: {
                    'filePath': this.updateformdata.fileUrl,
                    'fileName': this.updateformdata.fileName
                }//传给后台的参数
            };
            this.$downloadcommon(obj);
        },
        blobToDataURI(blob, callback) {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function(e) {
                callback(e.target.result);
            };
        },
        addDetail() {
            this.feeInvoiceDetailList.push({
                lineNumber: '',
                goodsCode: '',
                unit: '',
                quantity: '',
                amount: '',
                taxRate: '',
                goodsName: '',
                specificationModel: '',
                unitPrice: '',
                taxAmount: ''
            });
        },
        deleteDetail(index) {
            this.feeInvoiceDetailList.splice(index, 1);
        },
    }
};
</script>

<style scoped='scoped' lang='less'>
/deep/ .el-dialog__body {
    padding-top: 5px;
}

/deep/ .el-form-item__label {
    font-size: 13px;
}

/deep/ .el-form-item {
    margin-bottom: 8px !important;
}

/deep/ .el-input--small .el-input__inner {
    // width: 180px !important;
    height: 28px !important;
    line-height: 28px !important;
}

.fprightimg {
    width: 70%;
    height: 90vh;
    overflow: auto;
    position: relative;
    display: flex;
    margin-left: 15px;;
    /*justify-content: center;*/
}

.fprightimg > img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    margin: auto;
}

.fprightimg > #pic_cwctImg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    margin: auto;
}

.titledetail {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    padding-top: 10px;
}

.detail-title {
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    margin-bottom: 8px;
    padding-left: 5px;
    border-left: 3px solid #20a0ff;
}
</style>
